'use client';

import { InMemoryCache } from '@apollo/client';
import { useMemo } from 'react';
import { KaktuAuthClient } from '..';
import { AuthProvider } from './provider';
import { ApolloProvider } from '../../api/apollo/provider';
import { StorageProvider } from '../../api/storage/provider';

// Create a singleton instance of the auth client
let authClientInstance: KaktuAuthClient | null = null;

function getAuthClient() {
  if (authClientInstance) {
    return authClientInstance;
  }

  const authUrl = process.env.REACT_APP_AUTH_URL;

  if (!authUrl) {
    throw new Error('REACT_APP_AUTH_URL environment variable is not defined');
  }

  authClientInstance = new KaktuAuthClient({
    refreshIntervalTime: 60 * 60,
    autoRefreshToken: true,
    url: authUrl!,
  });

  return authClientInstance;
}

// Create a singleton cache instance
const cache = new InMemoryCache();

export function AuthWrapper({ children }: React.PropsWithChildren) {
  const client = useMemo(() => getAuthClient(), []); // Use memoized singleton client
  if (!process.env.REACT_APP_GRAPHQL_URL) {
    throw new Error('REACT_APP_GRAPHQL_URL environment variable is not defined');
  }
  const graphqlUrl = process.env.REACT_APP_GRAPHQL_URL;

  return (
    <AuthProvider auth={client}>
        <ApolloProvider cache={cache} auth={client} graphqlUrl={graphqlUrl}>
          <StorageProvider>
            {children}
          </StorageProvider>
        </ApolloProvider>
    </AuthProvider>
  );
}
